import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import PaginateList from "../../../utils/PaginateList";
import * as ProviderServices from "../../../../services/ProviderService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import {
  ButtonAction,
  ButtonClose,
  Icon,
  Option,
  ListOptions,
} from "./providerList.styled";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import {} from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const ProviderListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);

  const columns = [
    {
      header: t("forms.provider.table.heads.name"),
      accessorKey: "name",
      cell: (info) => {
        if (i18n.language === "pt") {
          return info.row.original.namePt;
        }

        return info.getValue();
      },
      size: 200,
    },
    {
      Header: " ",
      accessorKey: " ",
      cell: (info) => renderAction(info.row.original),
      size: 60,
    },
  ];

  const goToEdit = (uuid) => {
    navigate(`/user/provider/form/update/${uuid}`);
  };

  const renderAction = (data) => {
    return (
      <div className="text-center">
        <ButtonAction onClick={() => goToEdit(data.uuid)} type="button">
          <i className="fa-regular fa-pen-to-square"></i>
        </ButtonAction>
        <ButtonAction
          onClick={() => showDialogOnDelete(data.uuid)}
          type="button"
        >
          <Icon className="fa-solid fa-trash-can"></Icon>
        </ButtonAction>
      </div>
    );
  };

  const showDialogOnDelete = (uuid) => {
    const okAction = async () => {
      ProviderServices.deleteProvider(uuid).then((result) => {
        if (result && result.deleted === true) {
          setForceRefresh(true);
        }
      });
    };

    const cancelAction = () => {};

    ShowAlertDialog(
      t("forms.provider.dialog.remove.title"),
      t("forms.provider.dialog.remove.text"),
      "warning",
      true,
      t("forms.provider.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.provider.dialog.remove.buttonNo"),
      cancelAction
    );
  };

  const listData = async (filter) => {
    // if (sortBy) {
    //   filter.sort = sortBy;
    // } else {
    //   filter.sort = "-date";
    // }
    const result = await ProviderServices.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  return (
    <PaginateList
      refresh={forceRefresh}
      filters={filters}
      columns={columns}
      toList={listData}
      hideColum={hideColumn}
      resize={resize}
      resetRefresh={() => setForceRefresh(false)}
    ></PaginateList>
  );
};

ProviderListContainer.propTypes = {
  filters: PropTypes.object,
};

export default ProviderListContainer;
